import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCommunicationProgramDetails, clearCommunicationProgramDetails } from 'app/actions/CommunicationProgramActions';
import { getCommunicationsProgramDetails, getIsLoadingCommunicationsProgramDetails } from 'app/reducers';
import isEmpty from 'app/utils/IsEmpty';

export default function CommunicationProgramDetailsContainer(props) {
    const dispatch = useDispatch();

    let column = '';
    let limit = 0;
    let offset = 0;
    let order = '';
    const pagination = props.pagination;
    const sorter = props.sorter;
    let communicationProgramDetails = useSelector(getCommunicationsProgramDetails);
    let isLoading = useSelector(getIsLoadingCommunicationsProgramDetails);

    const {
        Roles
    } = useSelector(state => state.Auth.item.User);

    const IsSuperAdmin = () => {
        for (const rol of Roles) {
            if (rol.NameRole.includes('Super Administrador')) {
                return true;
            }

        }
        return null;
    }

    const columns = [
        {
            title: 'General',
            dataIndex: 'specialtyName',
            key: 'specialtyName',
            sorter: true,
            width: 550
        },
        {
            title: 'Aprobados',
            dataIndex: 'finished',
            key: 'finished',
            //sorter: true,
            width: 120,
            ellipsis: true

        },
        {
            title: 'Comunicados',
            dataIndex: 'communicated',
            key: 'communicated',
            //sorter: true,
            width: 120
        },
        {
            title: 'Pendientes',
            dataIndex: 'pending',
            key: 'pending',
            //sorter: true,
            width: 120,
        },
        {
            title: 'Cumplimiento',
            dataIndex: 'compliance' /*statusName*/,
            key: 'compliance' /*statusName*/,
            sorter: true,
            width: 120,
            render: (text, record) => (
                text ? text + ' %' : '0%'
            )
        },
    ];


    useEffect(() => {
        if (isEmpty(communicationProgramDetails)) fetchCommunicationProgramDetailsAction();
    }, []);

    const handleTableChange = (pagination, filters, sorter) => {
        props.setPagination(pagination);
        props.setSorter(sorter);
        if (Object.keys(sorter).length > 0) {
            column = sorter.field;
            order = sorter.order === "ascend" ? "ASC" : "DESC";
        }
        else {
            column = '';
            order = '';
        }
        dispatch(clearCommunicationProgramDetails());

        var respnse = IsSuperAdmin();

        dispatch(fetchCommunicationProgramDetails(
            {
                frontId: (typeof props.formData.frontId === "undefined") ? '' : props.formData.frontId,
                sortColumn: column,
                sortDir: order,
                offset: ((pagination.current - 1) * pagination.pageSize),
                limit: pagination.pageSize,
                EsSuperAdmin: respnse ? 1 : 0
            }, props.idCommunicationProgram));
    };

    //Load
    if (pagination != null) {
        offset = (0 * pagination.pageSize);
        limit = (pagination.pageSize);

        if (!isLoading && communicationProgramDetails.length > 0) {
            pagination.total = communicationProgramDetails[0].totalcount;
        }
        else {
            pagination.total = 0;
        }
    }

    if (sorter !== null) {
        column = sorter.field;
        order = sorter.order === "ascend" ? "ASC" : "DESC";
    }
    const fetchCommunicationProgramDetailsAction = () => {
        var respnse = IsSuperAdmin();

        dispatch(fetchCommunicationProgramDetails({
            sortColumn: column === undefined ? '' : column,
            sortDir: order, offset: offset, limit: limit
            , EsSuperAdmin: respnse ? 1 : 0
        }, props.idCommunicationProgram));
    }



    communicationProgramDetails.forEach((i) => {
        if (i.listCourses !== null) {
            if (Object.keys(i.listCourses).length > 0) {
                i.listCourses.forEach((item) => {
                    item['specialtyName'] = item.courseName; //Text to show first columns (children) not real specialty
                    item['children'] = [...item.listCategory]
                    item.listCategory.forEach((a) => {
                        a['specialtyName'] = a.categoryName; //Text to show first columns (children) not real specialty
                        a['idSpecialty'] = i.idSpecialty;
                        a['idCourse'] = item.idCourse;
                        a['key'] = a.idCategory;
                        a['courseName'] = item.courseName;
                        a['specialtyNameReal'] = i.specialtyName;//Real spacialty name
                    })
                    i['children'] = [...i.listCourses]
                })
            }
        }
    })
    
    return (props.children({ pagination: pagination, cols: columns, communicationProgramDetails, isLoading, handleTableChange: handleTableChange }));
}